"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Help2_exports = {};
__export(Help2_exports, {
  default: () => Help2_default
});
module.exports = __toCommonJS(Help2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 1.91016C11.6458 1.91016 12.7266 2.13151 13.7422 2.57422C14.7578 3.00391 15.6432 3.59635 16.3984 4.35156C17.1536 5.10677 17.7461 5.99219 18.1758 7.00781C18.6185 8.02344 18.8398 9.10417 18.8398 10.25C18.8398 11.3958 18.6185 12.4766 18.1758 13.4922C17.7461 14.5078 17.1536 15.3932 16.3984 16.1484C15.6432 16.9036 14.7578 17.4961 13.7422 17.9258C12.7266 18.3685 11.6458 18.5898 10.5 18.5898C9.35417 18.5898 8.27344 18.3685 7.25781 17.9258C6.24219 17.4961 5.35677 16.9036 4.60156 16.1484C3.84635 15.3932 3.25391 14.5078 2.82422 13.4922C2.38151 12.4766 2.16016 11.3958 2.16016 10.25C2.16016 9.10417 2.38151 8.02344 2.82422 7.00781C3.25391 5.99219 3.84635 5.10677 4.60156 4.35156C5.35677 3.59635 6.24219 3.00391 7.25781 2.57422C8.27344 2.13151 9.35417 1.91016 10.5 1.91016ZM10.5 2.75C9.45833 2.75 8.48828 2.94531 7.58984 3.33594C6.67839 3.72656 5.8776 4.26693 5.1875 4.95703C4.51042 5.63411 3.97656 6.42839 3.58594 7.33984C3.19531 8.23828 3 9.20833 3 10.25C3 11.2917 3.19531 12.2617 3.58594 13.1602C3.97656 14.0716 4.51042 14.8724 5.1875 15.5625C5.8776 16.2396 6.67839 16.7734 7.58984 17.1641C8.48828 17.5547 9.45833 17.75 10.5 17.75C11.5417 17.75 12.5117 17.5547 13.4102 17.1641C14.3216 16.7734 15.1159 16.2396 15.793 15.5625C16.4831 14.8724 17.0234 14.0716 17.4141 13.1602C17.8047 12.2617 18 11.2917 18 10.25C18 9.20833 17.8047 8.23828 17.4141 7.33984C17.0234 6.42839 16.4831 5.63411 15.793 4.95703C15.1159 4.26693 14.3216 3.72656 13.4102 3.33594C12.5117 2.94531 11.5417 2.75 10.5 2.75ZM10.5586 5.25C11.6523 5.3151 12.4987 5.67318 13.0977 6.32422C13.6966 6.97526 13.9961 7.78906 13.9961 8.76562C13.9831 9.52083 13.7552 10.1263 13.3125 10.582C12.8828 11.0378 12.2773 11.3372 11.4961 11.4805L11.3398 11.5195V12.75C11.3398 12.9583 11.2682 13.1471 11.125 13.3164C10.9818 13.4727 10.806 13.5573 10.5977 13.5703L10.5 13.5898C10.2917 13.5898 10.1029 13.5182 9.93359 13.375C9.77734 13.2318 9.69271 13.056 9.67969 12.8477L9.66016 12.75V10.7578L10.4805 9.91797C11.1576 9.90495 11.6328 9.80729 11.9062 9.625C12.1797 9.42969 12.3229 9.13672 12.3359 8.74609C12.3359 8.21224 12.1862 7.78255 11.8867 7.45703C11.5872 7.13151 11.1315 6.94922 10.5195 6.91016C9.86849 6.9362 9.39323 7.09245 9.09375 7.37891C8.80729 7.66536 8.66406 8.12109 8.66406 8.74609C8.66406 8.98047 8.57943 9.18229 8.41016 9.35156C8.25391 9.50781 8.05859 9.58594 7.82422 9.58594C7.60286 9.58594 7.40755 9.50781 7.23828 9.35156C7.08203 9.18229 7.00391 8.98047 7.00391 8.74609C7.00391 7.66536 7.3099 6.82552 7.92188 6.22656C8.53385 5.61458 9.40625 5.28906 10.5391 5.25H10.5586ZM10.5 14.4102C10.7344 14.4102 10.9297 14.4948 11.0859 14.6641C11.2552 14.8203 11.3398 15.0156 11.3398 15.25C11.3398 15.4844 11.2552 15.6862 11.0859 15.8555C10.9297 16.0117 10.7344 16.0898 10.5 16.0898C10.2656 16.0898 10.0638 16.0117 9.89453 15.8555C9.73828 15.6862 9.66016 15.4844 9.66016 15.25C9.66016 15.0156 9.73828 14.8203 9.89453 14.6641C10.0638 14.4948 10.2656 14.4102 10.5 14.4102Z",
      fill: "currentColor"
    }
  )
);
const SvgHelp2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Help2_default = SvgHelp2;
